import {Injectable} from "@angular/core";
import {FormGroup, ValidationErrors, ValidatorFn} from "@angular/forms";
import {sanitizeDate} from "../../../umbrella-common/common-functions";
import {isBeforeOrNull, isInPast} from "../../../umbrella-common/date-functions";

@Injectable()
export class TransferAuditDatesValidatorsService {

	desiredNextAuditDateValidator(): ValidatorFn {
		return control => {
			return this.validateDesiredNextAuditDate(sanitizeDate(new Date(control.value)));
		};
	}

	lastAuditPerformedDateValidator(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const dates: CurrentCertificateDates = {
				lastAuditPerformedDate: sanitizeDate(new Date(control.value)),
				expirationDate: sanitizeDate(new Date(form.get('expirationDate' + formKey).value)),
			};
			return this.validateLastAuditPerformedDate(dates);
		};
	}

	expirationDateValidator(form: FormGroup, formKey: string): ValidatorFn {
		return control => {
			const dates: CurrentCertificateDates = {
				lastAuditPerformedDate: sanitizeDate(new Date(form.get('lastAuditPerformedDate' + formKey).value)),
				expirationDate: sanitizeDate(new Date(control.value)),
			};
			return this.validateExpirationDate(dates);
		};
	}

	private validateDesiredNextAuditDate(desiredNextAuditDate: Date): ValidationErrors | null {
		const dateInPast = isInPast(desiredNextAuditDate);

		if (!dateInPast) {
			return null;
		} else {
			return {desiredNextAuditDateInPast: []};
		}
	}

	private validateLastAuditPerformedDate(dates: CurrentCertificateDates): ValidationErrors | null {
		const empty: boolean = !dates.lastAuditPerformedDate;
		const dateInPast: boolean = isInPast(dates.lastAuditPerformedDate);
		const expirationDateAfterLastAuditPerformedDate: boolean = isBeforeOrNull(dates.lastAuditPerformedDate, dates.expirationDate);

		if (!empty && expirationDateAfterLastAuditPerformedDate && dateInPast) {
			return null;
		} else if (empty) {
			return {required: []};
		} else {
			let errors: ValidationErrors = !dateInPast ? {lastAuditPerformedDateInFuture: []} : {};
			if (!expirationDateAfterLastAuditPerformedDate) {
				errors = Object.assign(errors, {lastAuditPerformedDateBeforeExpirationDate: []});
			}
			return errors;
		}
	}

	private validateExpirationDate(dates: CurrentCertificateDates): ValidationErrors | null {
		const empty: boolean = !dates.expirationDate;
		const expirationDateAfterLastAuditPerformedDate: boolean = isBeforeOrNull(dates.lastAuditPerformedDate, dates.expirationDate);
		if (empty) {
			return {required: []};
		} else if (!expirationDateAfterLastAuditPerformedDate) {
			return {expirationDateAfterLastAuditPerformedDate: []};
		}
		return null;
	}

	expirationDateIsInPastOrClose(expirationDate) {
		const date = sanitizeDate(new Date(expirationDate));
		return date != null && (isInPast(date) || isBeforeOrNull(date, this.getDateInTwoWeeks()));
	}

	private getDateInTwoWeeks(): Date {
		const now: Date = new Date();
		const result = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		result.setDate(result.getDate() + 15);
		return result;
	}
}

interface CurrentCertificateDates {
	lastAuditPerformedDate: Date;
	expirationDate: Date;
}
